/* eslint-disable no-underscore-dangle */
import Cookie from 'js-cookie';
import { lifecycle } from 'recompose';
import { compose, not, isEmpty, pathOr, pathEq } from 'ramda';

import { EVIDON_GDPR_CONSENT_COOKIE } from 'app/features/footer/constants';
import NullComponent from 'app/components/NullComponent/NullComponent';

const EVIDON_PREFERENCES_ACCEPT_BTN_ID = 'evidon-prefdiag-accept';
const EVIDON_BANNER_ACCEPT_BTN_ID = '_evidon-accept-button';
const EVIDON_PREFERENCES_CHANGE_RELOAD_DELAY = 100;

const setEvidonGDPRConsentCookie = () => {
  Cookie.set(EVIDON_GDPR_CONSENT_COOKIE, 1, {
    path: window.evidon.notice._getConsentCookieDomainPath(),
    expires: window.evidon.notice._getConsentCookieExpDate(),
  });
};

const isGDPR = () => window.evidon?.notice?.isGDPR();

const isBannerAcceptButtonClicked = pathEq(
  ['target', 'id'],
  EVIDON_BANNER_ACCEPT_BTN_ID,
);

const isPreferencesAcceptButtonClicked = pathEq(
  ['target', 'id'],
  EVIDON_PREFERENCES_ACCEPT_BTN_ID,
);

const haveEvidonCategoriesLoaded = () =>
  compose(
    not,
    isEmpty,
    pathOr({}, ['evidon', 'notice', 'optOutDetails', 'categories']),
  )(window);

const handleEvidonConsentButtonClick = e => {
  if (isBannerAcceptButtonClicked(e) && isGDPR()) {
    setEvidonGDPRConsentCookie();
    window.evidon.banner.destroyNotice();
  }

  if (isPreferencesAcceptButtonClicked(e) && haveEvidonCategoriesLoaded()) {
    if (isGDPR() && !Cookie.get(EVIDON_GDPR_CONSENT_COOKIE)) {
      setEvidonGDPRConsentCookie();
    }

    setTimeout(
      () => window.location.reload(),
      EVIDON_PREFERENCES_CHANGE_RELOAD_DELAY,
    );
  }
};

function componentDidMount() {
  document.addEventListener('click', handleEvidonConsentButtonClick);
}

function componentWillUnmount() {
  document.removeEventListener('click', handleEvidonConsentButtonClick);
}

const EvidonRefreshHotfix = lifecycle({
  componentDidMount,
  componentWillUnmount,
})(NullComponent);

export {
  componentDidMount,
  componentWillUnmount,
  handleEvidonConsentButtonClick,
  setEvidonGDPRConsentCookie,
};

export default EvidonRefreshHotfix;
